import styled from 'styled-components'

import EmptyStateUnstyled from '../../components/EmptyState'

export const EmptyState = styled(EmptyStateUnstyled)`
  margin: 0 auto;
`
